"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Component = _interopRequireDefault(require("./Component"));

var _ButtonControls = _interopRequireDefault(require("./buttons/ButtonControls"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

/**
 * A `Button` is a component that triggers an event when clicked and supports a toggleable
 * selected state.
 *
 * @export
 * @class Button
 * @extends {Component<T, S>}
 * @implements {IToggleable}
 * @template T
 * @template S
 */
var Button =
/** @class */
function (_super) {
  __extends(Button, _super);
  /**
   * Initializes and returns a button instance with the specified configuration options.
   *
   * @param {*} [opts]
   * @memberof Button
   */


  function Button(opts) {
    var _this = this;

    opts = (0, _utils.extend)({
      toggleable: true,
      controls: {
        close: true,
        activity: true
      }
    }, opts, {
      className: opts.className ? "ui-btn " + opts.className : 'ui-btn',
      ui: {
        target: '.awxjs__ui-btn-target',
        label: '.awxjs__ui-btn-label',
        close: '.awxjs__ui-btn-close',
        settings: '.awxjs__ui-btn-settings',
        controls: '.awxjs__ui-btn-controls'
      }
    });
    opts.id = opts.id || (opts.value ? opts.value.replace(/,/g, '__') : null);
    _this = _super.call(this, opts) || this;

    if (opts.controls) {
      _this._controls = new _ButtonControls.default({
        controls: opts.controls
      });
    }

    _this.setState({
      selected: false
    });

    _this.initialize();

    return _this;
  }

  Object.defineProperty(Button.prototype, "id", {
    /**
     * Button identifier.
     *
     * @readonly
     * @type {string}
     * @memberof Button
     */
    get: function () {
      return this.opts.id || this.opts.value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "selected", {
    /**
     * A Boolean indicated whether the button is currently selected.
     *
     * @readonly
     * @type {boolean}
     * @memberof Button
     */
    get: function () {
      var selected = this.state.selected;
      return selected;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "toggleable", {
    get: function () {
      return this.opts.toggleable;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "controls", {
    get: function () {
      return this._controls;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "value", {
    /**
     * Value associated with the button, if any.
     *
     * @readonly
     * @type {*}
     * @memberof Button
     */
    get: function () {
      return this.opts.value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "title", {
    /**
     * Title label displayed for the button.
     *
     * @readonly
     * @type {string}
     * @memberof Button
     */
    get: function () {
      return this.opts.title;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "options", {
    /**
     * Custom data associated with the button, if any.
     *
     * @readonly
     * @type {*}
     * @memberof Button
     */
    get: function () {
      return this.opts.options;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Selects the button.
   *
   * @memberof Button
   */

  Button.prototype.select = function () {
    if (this.selected === false) {
      this.setState({
        selected: true
      });
      this.$el.addClass('selected');

      this._onSelect();
    }
  };
  /**
   * Deselects the button.
   *
   * @memberof Button
   */


  Button.prototype.deselect = function () {
    if (this.selected) {
      this.setState({
        selected: false
      });
      this.$el.removeClass('selected');

      this._onDeselect();
    }
  };
  /**
   * Enables or disables the button.
   * If disabled, button will not react to click events.
   */


  Button.prototype.disable = function (value) {
    this.$el.attr('data-disabled', value ? 1 : 0);
  };

  Button.prototype.setLoading = function (loading) {
    if (this.controls) {
      this.controls.setLoading(loading);
    }
  };

  Button.prototype._onSelect = function () {
    this.trigger(Button.Event.SELECT, {
      id: this.id,
      value: this.value,
      options: this.options
    });
  };

  Button.prototype._onDeselect = function () {
    this.trigger(Button.Event.DESELECT, {
      id: this.id,
      value: this.value,
      options: this.options
    });
  };

  Button.prototype._render = function () {
    return "\n\t\t\t<div class=\"awxjs__ui-btn\">\n\t\t\t\t<div class=\"awxjs__ui-btn-target\">\n\t\t\t\t\t<div class=\"awxjs__ui-btn-label\">" + this.opts.title + "</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
  };

  Button.prototype._onAddedToDOM = function () {
    _super.prototype._onAddedToDOM.call(this);

    this.$el.attr('data-id', this.id);

    if (this.opts.selected) {
      this.select();
    }

    if (this.controls) {
      this.controls.addToButton(this);
    }
  };

  Button.prototype._setupEvents = function () {
    var _this = this;

    _super.prototype._setupEvents.call(this);

    this.$el.on('click', function (e) {
      e.stopPropagation();
      var disabled = (0, _utils.toBool)(_this.$el.attr('data-disabled')) || false;

      if (!disabled) {
        if (_this.selected) {
          if (_this.toggleable) {
            _this.deselect();
          }
        } else {
          _this.select();
        }
      }
    });
    var controls = this.controls;

    if (controls) {
      controls.on('change', function (e) {
        _this.trigger('control:change', {
          id: _this.id,
          value: _this.value,
          control: __assign({}, e.data)
        });
      });

      if (controls.ui.settings && !this.opts.selected) {
        controls.ui.settings.hide();
      }

      if (controls.ui.close) {
        this.ui.target.on('mouseenter', function () {
          if (_this.$el.hasClass('selected') && (0, _utils.toBool)(_this.$el.attr('data-disabled')) !== true) {
            controls.ui.close.css('opacity', 1);
          }
        }).on('mouseleave', function (e) {
          controls.ui.close.css('opacity', 0);
        });
      }
    }
  };
  /**
   * Events that can be triggered by a `Button` instance.
   *
   * @static
   * @memberof Button
   */


  Button.Event = {
    /** Fired when the button is selected. */
    SELECT: 'select',

    /** Fired when the button is deselected. */
    DESELECT: 'deselect'
  };
  return Button;
}(_Component.default);

var _default = Button;
exports.default = _default;
module.exports = exports.default;